import useCurrentMarketplaceId from 'src/components/presentationals/buyer-dashboard/shared/hooks/marketplaces/useCurrentMarketplaceId'
import { useUserBuyerCompanyId } from 'src/contexts/userContext'
import { useRecursiveBuyerCompaniesQuery } from 'src/queries/seller/buyerCompanies/buyerCompanies'
import { useMarketplacesQuery } from 'src/queries/shared/marketplaces/marketplaces'
import { useRecursiveSellerCompaniesQuery } from 'src/queries/shared/sellerCompanies/sellerCompanies'

import { formatConversationContacts, transformCompanyToContact } from './chatContacts.utils'

const useChatContacts = () => {
  const buyerCompanyId = useUserBuyerCompanyId()
  const currentMarketplaceId = useCurrentMarketplaceId()
  const { data: marketplaces } = useMarketplacesQuery()

  const { data: buyerCompanies, isInitialLoading: isLoadingBuyer } =
    useRecursiveBuyerCompaniesQuery({
      queryParams: {
        canUseChat: true,
        hasContract: true,
        hasConnectedRoute: true,
      },
    })

  const { data: sellerCompanies, isInitialLoading: isLoadingSeller } =
    useRecursiveSellerCompaniesQuery({
      queryOptions: { enabled: !!buyerCompanyId },
      queryParams: { buyerCompanyId, canUseChat: true, connected: true },
    })

  const contacts = (buyerCompanyId ? sellerCompanies : buyerCompanies).map(
    transformCompanyToContact
  )

  return {
    contacts: formatConversationContacts({
      contacts,
      currentMarketplaceId,
      marketplaces,
    }),
    isLoading: isLoadingBuyer || isLoadingSeller,
  }
}

export default useChatContacts
